export default {
  hasBackboxTooltip: {
    id: 'bo_seller.listings.listings_table.market_list.backbox_tooltip',
    defaultMessage: 'You have the BackBox in {country}',
  },
  doesNotHaveBackboxTooltip: {
    id: 'bo_seller.listings.listings_table.market_list.no_backbox_tooltip',
    defaultMessage: 'You do not have the BackBox in {country}',
  },
  offlineProductToolTip: {
    id: 'bo_seller.listings.listings_table.market_list.product_offline_tooltip',
    defaultMessage: 'This product is offline in {country}',
  },
  marketCountryLabelAT: {
    id: 'bo_seller.listings.listings_table.market_list.country.austria',
    defaultMessage: 'Austria',
  },
  marketCountryLabelAU: {
    id: 'bo_seller.listings.listings_table.market_list.country.australia',
    defaultMessage: 'Australia',
  },
  marketCountryLabelBE: {
    id: 'bo_seller.listings.listings_table.market_list.country.belgium',
    defaultMessage: 'Belgium',
  },
  marketCountryLabelDE: {
    id: 'bo_seller.listings.listings_table.market_list.country.germany',
    defaultMessage: 'Germany',
  },
  marketCountryLabelES: {
    id: 'bo_seller.listings.listings_table.market_list.country.spain',
    defaultMessage: 'Spain',
  },
  marketCountryLabelFI: {
    id: 'bo_seller.listings.listings_table.market_list.country.finland',
    defaultMessage: 'Finland',
  },
  marketCountryLabelFR: {
    id: 'bo_seller.listings.listings_table.market_list.country.france',
    defaultMessage: 'France',
  },
  marketCountryLabelGB: {
    id: 'bo_seller.listings.listings_table.market_list.country.gb',
    defaultMessage: 'the United Kingdom',
  },
  marketCountryLabelGR: {
    id: 'bo_seller.listings.listings_table.market_list.country.gr',
    defaultMessage: 'Greece',
  },
  marketCountryLabelIE: {
    id: 'bo_seller.listings.listings_table.market_list.country.ie',
    defaultMessage: 'Ireland',
  },
  marketCountryLabelIT: {
    id: 'bo_seller.listings.listings_table.market_list.country.it',
    defaultMessage: 'Italy',
  },
  marketCountryLabelJP: {
    id: 'bo_seller.listings.listings_table.market_list.country.jp',
    defaultMessage: 'Japan',
  },
  marketCountryLabelNL: {
    id: 'bo_seller.listings.listings_table.market_list.country.nl',
    defaultMessage: 'the Netherlands',
  },
  marketCountryLabelPT: {
    id: 'bo_seller.listings.listings_table.market_list.country.pt',
    defaultMessage: 'Portugal',
  },
  marketCountryLabelSE: {
    id: 'bo_seller.listings.listings_table.market_list.country.se',
    defaultMessage: 'Sweden',
  },
  marketCountryLabelSK: {
    id: 'bo_seller.listings.listings_table.market_list.country.sk',
    defaultMessage: 'Slovakia',
  },
  marketCountryLabelUS: {
    id: 'bo_seller.listings.listings_table.market_list.country.us',
    defaultMessage: 'the United States',
  },
}
